import { render, staticRenderFns } from "./PriceWatcher.vue?vue&type=template&id=1c090bed"
import script from "./PriceWatcher.vue?vue&type=script&lang=js"
export * from "./PriceWatcher.vue?vue&type=script&lang=js"
import style0 from "./PriceWatcher.vue?vue&type=style&index=0&id=1c090bed&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c090bed')) {
      api.createRecord('1c090bed', component.options)
    } else {
      api.reload('1c090bed', component.options)
    }
    module.hot.accept("./PriceWatcher.vue?vue&type=template&id=1c090bed", function () {
      api.rerender('1c090bed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PriceWatcher.vue"
export default component.exports